





















import { Component, Mixins, Prop } from "vue-property-decorator";
import Enumerable from "linq";
import {
  NavigationPane,
  IButton,
  IButtonState,
} from "../../../panes";
import { DocumentSummaryEditableMixin } from "../../mixins";
import { IDocumentSummaryEditMenuRestrictions } from ".";
import { IRestriction } from "../../../../components/system";

interface IButtons {
  print: IButton;
  selectAndPrint: IButton;
  edit: IButton;
  show: IButton;
  quote: IButton;
  quoteAutomatically: IButton;
  copy: IButton;
  editNote: IButton;
  delete: IButton;
}

@Component({
  components: {
    NavigationPane,
  },
})
export default class DocumentSummaryEditMenu extends Mixins(DocumentSummaryEditableMixin) {
  private static readonly _buttons: IButtons = {
    print: {
      name: "印刷",
      description: "選択されている文書を印刷します。",
      iconClass: "print",
    },
    selectAndPrint: {
      name: "印刷(選択)",
      description: "選択されている文書を出力先を選択して印刷します。",
      iconClass: "select-and-print",
    },
    edit: {
      name: "編集",
      description: "選択されている文書を編集できます。",
      iconClass: "edit",
    },
    show: {
      name: "参照",
      description: "選択されている文書を別画面で表示します。",
      iconClass: "show-document",
    },
    quote: {
      name: "引用転記",
      description: "選択されている文書を引用した新規文書を作成します。",
      iconClass: "quote-and-edit",
    },
    quoteAutomatically: {
      name: "引用",
      description: "選択されている文書を引用した新規文書を作成します。",
      iconClass: "quote-and-edit",
    },
    copy: {
      name: "コピー",
      description: "選択されている文書をコピーした新規文書を作成します。",
      iconClass: "copy-and-edit",
    },
    editNote: {
      name: "文書メモ",
      description: "選択されている文書の文書メモを編集します。",
      iconClass: "document",
    },
    delete: {
      name: "削除",
      description: "選択されている文書を削除します。",
      iconClass: "delete",
    },
  };

  get buttons(): IButtonState[] {
    return Enumerable.from([
      {
        definition: DocumentSummaryEditMenu._buttons.print,
        isVisible: this.isButtonVisible(r => r.print) && this.isPrintable,
        isEnable: this.isDocumentReadable && this.isDocumentPrintable,
        onClick: () => this.printDocument(),
      },
      {
        definition: DocumentSummaryEditMenu._buttons.selectAndPrint,
        isVisible: this.isButtonVisible(r => r.selectAndPrint) && this.isPrintable,
        isEnable: this.isDocumentReadable && this.isDocumentPrintable,
        onClick: () => this.selectAndPrintDocument(),
      },
      {
        definition: DocumentSummaryEditMenu._buttons.edit,
        isVisible: this.isButtonVisible(r => r.edit) && this.isEditable,
        isEnable: this.isDocumentWritable && !this.isDocumentDeleted && !this.isDocumentFixed && !this.isVirtual,
        onClick: () => this.editDocument(),
      },
      {
        definition: DocumentSummaryEditMenu._buttons.show,
        isVisible: this.isButtonVisible(r => r.show),
        isEnable: this.isDocumentReadable,
        onClick: () => this.showDocument(),
      },
      {
        definition: DocumentSummaryEditMenu._buttons.quote,
        isVisible: this.isButtonVisible(r => r.quote) && this.isQuotable,
        isEnable: this.isDocumentReadable && !this.isArchiveSelected && this.isDocumentQuotable && !this.isVirtual,
        onClick: () => this.editNewQuotedDocument(),
      },
      {
        definition: DocumentSummaryEditMenu._buttons.quoteAutomatically,
        isVisible: this.isButtonVisible(r => r.quote) && this.isAutomaticallyQuotable,  // restrictionはquoteを流用している
        isEnable: this.isDocumentReadable && !this.isArchiveSelected && this.isDocumentQuotable && !this.isVirtual,
        onClick: () => this.editNewAutomaticallyQuotedDocument(),
      },
      {
        definition: DocumentSummaryEditMenu._buttons.copy,
        isVisible: this.isButtonVisible(r => r.copy) && this.isCopyable,
        isEnable: this.isDocumentReadable && !this.isArchiveSelected && this.isDocumentCopyable && !this.isVirtual,
        onClick: () => this.editNewCopiedDocument(),
      },
      {
        definition: DocumentSummaryEditMenu._buttons.editNote,
        isVisible: this.isButtonVisible(r => r.editNote),
        isEnable: this.isNoteWritable && !this.isVirtual,
        onClick: () => this.editDocumentNote(),
      },
      {
        definition: DocumentSummaryEditMenu._buttons.delete,
        isVisible: this.isButtonVisible(r => r.delete) && this.isDeletable,
        isEnable: this.isDocumentRemovable && !this.isDocumentDeleted && !this.isDocumentFixed && !this.isVirtual,
        onClick: () => this.deleteDocument(),
      },
    ])
    .where(b => b.isVisible)
    .toArray();
  }

  mounted(): void {
    // tabsがstaticのため、ここでタブの設定を読み込む
    this.setEditNoteButtonSetting();
  }

  @Prop()
  restrictions: IDocumentSummaryEditMenuRestrictions;

  private isButtonVisible(accessor: ((c: IDocumentSummaryEditMenuRestrictions) => IRestriction), defaultValue = true): boolean {
    return !this.restrictions || !accessor(this.restrictions)
      ? defaultValue
      : !accessor(this.restrictions).isDisabled;
  }

  private setEditNoteButtonSetting(): void {
    DocumentSummaryEditMenu._buttons.editNote.name = this.$wording.document.note;
    DocumentSummaryEditMenu._buttons.editNote.description = "選択されている文書の" + this.$wording.document.note + "を編集します。";
  }
}
